import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {Accordion, AccordionDetails, AccordionSummary, Grid, Typography} from '@mui/material';

import {TabProps} from './CompanyInfoToggle';
import {orangeColors} from '../../../../../layouts/theme/designSystem';

interface Props {
  leftTabContent: TabProps;
  rightTabContent: TabProps;
}
export const MobileDisplay = ({leftTabContent, rightTabContent}: Props) => {
  const bgColor = orangeColors[4];

  return (
    <Grid container>
      <Accordion id={`${leftTabContent.tab}`} sx={{width: '100%'}}>
        <AccordionSummary
          sx={{backgroundColor: bgColor}}
          expandIcon={<ExpandMoreIcon style={{color: orangeColors[100]}} />}
        >
          <Typography sx={{paddingLeft: '32px'}}>{leftTabContent.tab}</Typography>
        </AccordionSummary>
        <AccordionDetails>{leftTabContent.component}</AccordionDetails>
      </Accordion>
      <Accordion id={`${rightTabContent.tab}`} sx={{width: '100%'}}>
        <AccordionSummary
          sx={{backgroundColor: bgColor}}
          expandIcon={<ExpandMoreIcon style={{color: orangeColors[100]}} />}
        >
          <Typography sx={{paddingLeft: '32px'}}>{rightTabContent.tab}</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{padding: {xs: '16px'}}}>{rightTabContent.component}</AccordionDetails>
      </Accordion>
    </Grid>
  );
};
